var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C24 50.1217 24.8429 52.1566 26.3431 53.6569C27.8434 55.1571 29.8783 56 32 56C34.1217 56 36.1566 55.1571 37.6569 53.6569C39.1571 52.1566 40 50.1217 40 48",
    stroke: "#FFE500",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 6C49.8621 8.4643 52.9946 11.917 55.0725 16",
    stroke: "#FFE500",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92773 16C11.0057 11.917 14.1381 8.4643 18.0002 6",
    stroke: "#FFE500",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 28C13.9997 23.2261 15.8961 18.6477 19.2718 15.2721C22.6474 11.8964 27.2258 10 31.9997 10C36.7736 10 41.352 11.8964 44.7276 15.2721C48.1033 18.6477 49.9997 23.2261 49.9997 28C49.9997 36.955 52.0747 42.15 53.7247 45C53.8999 45.3035 53.9923 45.6478 53.9926 45.9982C53.993 46.3487 53.9012 46.6931 53.7265 46.997C53.5518 47.3008 53.3003 47.5534 52.9972 47.7294C52.6942 47.9055 52.3502 47.9988 51.9997 48H11.9997C11.6496 47.9979 11.3063 47.904 11.0039 47.7276C10.7015 47.5512 10.4508 47.2985 10.2767 46.9948C10.1025 46.6911 10.0112 46.3471 10.0117 45.997C10.0123 45.6469 10.1047 45.3032 10.2797 45C11.9272 42.15 13.9997 36.9525 13.9997 28Z",
    stroke: "#FFE500",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert2);
export default __webpack_public_path__ + "static/media/Alert2.8e989adb46def49b2e78fbd410d82e67.svg";
export { ForwardRef as ReactComponent };